import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, CircularProgress } from '@material-ui/core';
import { NavigateBefore, NavigateNext, Check } from '@material-ui/icons';
import styles from './WizardNavigation.module.scss';
import IntlMessages from 'util/IntlMessages';

const WizardNavigation = ({
  onPrev,
  onNext,
  onComplete,
  canGoPrev,
  canGoNext,
  isLastStep,
  loading,
}) => (
  <Box className={styles.root}>
    <Button
      variant="outlined"
      startIcon={<NavigateBefore />}
      onClick={onPrev}
      disabled={!canGoPrev || loading}
    >
      <IntlMessages id="appModule.back" />
    </Button>

    <Box id="wizard-navigation-center" className={styles.centerContent} />

    <Box className={styles.buttonGroup}>
      {!isLastStep && (
      <Button
        variant="contained"
        color="primary"
        endIcon={loading ? <CircularProgress size={20} /> : <NavigateNext />}
        onClick={onNext}
        disabled={!canGoNext || loading}
      >
        <IntlMessages id="appModule.next" />
      </Button>
      )}

      {isLastStep && onComplete && (
      <Button
        variant="contained"
        color="primary"
        startIcon={loading ? <CircularProgress size={20} /> : <Check />}
        onClick={onComplete}
        disabled={loading}
      >
        <IntlMessages id="ui.wizard.wizardNavigation.completeActivate" />
      </Button>
      )}

      {isLastStep && !onComplete && (
      <Button
        variant="contained"
        color="primary"
        endIcon={loading ? <CircularProgress size={20} /> : <NavigateNext />}
        onClick={onNext}
        disabled={!canGoNext || loading}
      >
        <IntlMessages id="appModule.next" />
      </Button>
      )}
    </Box>
  </Box>
);

WizardNavigation.propTypes = {
  onPrev: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onComplete: PropTypes.func,
  canGoPrev: PropTypes.bool.isRequired,
  canGoNext: PropTypes.bool.isRequired,
  isLastStep: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
};

WizardNavigation.defaultProps = {
  loading: false,
  onComplete: null,
};

export default WizardNavigation;
